import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'

import Firstpage from '@/components/Firstpage'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Settings from '@/components/Settings'
import Inventory from '@/components/Inventory'
import Customerorders from '@/components/Customerorders'
import Cart from '@/components/Cart'
import Consumercart from '@/components/consumer/Consumercart'
import Checkout from '@/components/consumer/Checkout'
import Breweryprofile from '@/components/Breweryprofile'
import Messagesholder from '@/components/Messagesholder'
import Singlemessagethreadholder from '@/components/Singlemessagethreadholder'
import Brewerevents from '@/components/Brewerevents'
import Allbeers from '@/components/Allbeers'
import Allbeersnoauth from '@/components/Allbeersnoauth'
import Createaccount from '@/components/Createaccount'
import Brewerdashboard from '@/components/Brewerdashboard'
import Brewerorders from '@/components/Brewerorders'
import Pastorders from '@/components/Pastorders'
import Welcomepagebrewer from '@/components/Welcomepagebrewer'
import Welcomepagepub from '@/components/Welcomepagepub'
import Distributorinventory from '@/components/Distributorinventory'
import Contact from '@/components/Contact'
import FAQ from '@/components/FAQ'
import Buyerprofile from '@/components/Buyerprofile'
import Subscribe from '@/components/Subscribe'
import Selecttype from '@/components/inventory/Selecttype'
import Drinkdetails from '@/components/inventory/Drinkdetails'
import Brewerinvoices from '@/components/seller/Brewerinvoices'
import Marketing from '@/components/seller/Marketing'
import Salesreport from '@/components/seller/Salesreport'
import Createinvoice from '@/components/seller/Createinvoice'
import Invoicescreated from '@/components/seller/Invoicescreated'
import Showinvoice from '@/components/common/Showinvoice'
import Buyerinvoices from '@/components/buyer/Buyerinvoices'
import Buyerservicerequests from '@/components/buyer/Buyerservicerequests'
import Sellerservicerequests from '@/components/seller/Sellerservicerequests'
import Unsubscribe from '@/components/buyer/Unsubscribe'
import Unsubscribepostoffering from '@/components/buyer/Unsubscribepostoffering'
import Consumerpo from '@/components/seller/Consumerpo'
import Receivables from '@/components/seller/Receivables'
import Composeemail from '@/components/seller/Composeemail'
import Emaildetails from '@/components/seller/Emaildetails'
import Selectcountiesforemail from '@/components/seller/Selectcountiesforemail'
import Toemails from '@/components/seller/Toemails'
import Managereps from '@/components/seller/Managereps'
import Consumerorders from '@/components/consumer/Consumerorders'
import Managebrewery from '@/components/seller/Managebrewery'

//Single pages for opening from email
import Ordermessage from '@/components/Ordermessage'
import Breweracceptorder from '@/components/Breweracceptorder'
import Orderfromemail from '@/components/buyer/Orderfromemail'

//Order change request
import Acceptorderchange from '@/components/buyer/Acceptorderchange'

import Forgotpassword from '@/components/Forgotpassword'
import Messageuser from '@/components/Messageuser'

import Landing from '@/components/Landing'

import Campaign from '@/components/seller/Campaign'

//Forums
import Forums from '@/components/forums/Forums'
import Forumthreaddetails from '@/components/forums/Forumthreaddetails'
import Unsubscribeforums from '@/components/forums/Unsubscribeforums'

//Intro pages
import Crafters from '@/components/Crafters'
import Buyers from '@/components/Buyers'

//For sale
import Additemforsale from '@/components/forsale/Additemforsale'
import Myitemsforsale from '@/components/forsale/Myitemsforsale'
import Tradingpost from '@/components/forsale/Tradingpost'
import Saleitemdetails from '@/components/forsale/Saleitemdetails'
import Cameraview from '@/components/forsale/Cameraview'
import Unsubscribetradingpost from '@/components/forsale/Unsubscribetradingpost'

//Signup
import Signup from '@/components/signup/Signup'
import Makeaccount from '@/components/signup/Makeaccount'

//Suggest order change
import Suggestorderchange from '@/components/seller/Suggestorderchange'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '*',
			redirect: '/login',
			metaTags: [
				{
				  name: 'Keg Seeker the brewer to buyer marketplace',
				  content: 'Kegseeker connects buyers directly with brewers'
				},
			]
			
		},
		{
			path: '/login',
			name: 'Firstpage',
			component: Firstpage
		},

		//Sign up
		{
			path: '/signup',
			name: 'Signup',
			component: Signup
		},
		//Sign up
		{
			path: '/makeaccount',
			name: 'Makeaccount',
			component: Makeaccount
		},


        {
			path: '/dashboard',
			name: 'Dashboard',
			component: Dashboard,
            meta: {
				requiresAuth: true,
				title: 'Dashboard',
				name: 'home',
				meta: {title: 'Home'}
            }
		},
        {
			path: '/settings',
			name: 'Settings',
			component: Settings,
            meta: {
				requiresAuth: true,
				name: 'Keg Country: Settings',
            }
		},
		//Reset password
		{
			path: '/forgotpassword',
			name: 'Forgotpassword',
			component: Forgotpassword,
            meta: {
				requiresAuth: false,
				name: 'Reset Password',
            }
		},

		{
			path: '/inventory',
			name: 'Inventory',
			component: Inventory,
            meta: {
                requiresAuth: true
            }
		},

		{
			path: '/cart',
			name: 'cart',
			component: Cart,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/consumercart',
			name: 'consumercart',
			component: Consumercart,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/checkout',
			name: 'checkout',
			component: Checkout,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/breweryprofile',
			name: 'breweryprofile',
			component: Breweryprofile,
			props: true,
			props: (route) => ({ brewerId: route.query.brewerId, distbrewerid: route.query.distbrewerid }),
            meta: {
                requiresAuth: false
			},
			
		},
		
		//For routing from emails etc
		{ path: '/brewers/:brewershortname', component: Breweryprofile },
		//For routing from emails with a beer link etc
		{ path: '/brewers/:brewershortname/:beerid', component: Breweryprofile },

		{
			path: '/buyerprofile',
			name: 'buyerprofile',
			component: Buyerprofile,
			props: true,
            meta: {
                requiresAuth: false
			},
			
		},

		{
			path: '/messagesholder',
			name: 'messagesholder',
			component: Messagesholder,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/singlemessagethreadholder',
			name: 'singlemessagethreadholder',
			component: Singlemessagethreadholder,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/brewerevents',
			name: 'brewerevents',
			component: Brewerevents,
            meta: {
                requiresAuth: true
			},
			
		},		
		{
			path: '/allbeers',
			name: 'allbeers',
			component: Allbeers,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/allbeersnoauth',
			name: 'allbeersnoauth',
			component: Allbeersnoauth,
			
		},

		{
			path: '/createaccount',
			name: 'createaccount',
			component: Createaccount,
            meta: {
                requiresAuth: false
			},
			
		},

		{
			path: '/brewerdashboard',
			name: 'brewerdashboard',
			component: Brewerdashboard,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/customerorders',
			name: 'customerorders',
			component: Customerorders,
            meta: {
                requiresAuth: true
			},
			
		},

		{
			path: '/consumerorders',
			name: 'consumerorders',
			component: Consumerorders,
            meta: {
                requiresAuth: true
			},
			
		},

		{
			path: '/brewerorders',
			name: 'brewerorders',
			component: Brewerorders,
            meta: {
                requiresAuth: true
			},
			
		},

		//Suggest order change
		{ path: '/suggestorderchange/:suborderid', component: Suggestorderchange },

		{
			path: '/pastorders',
			name: 'pastorders',
			component: Pastorders,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/welcomepagepub',
			name: 'welcomepagepub',
			component: Welcomepagepub,
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/welcomepagebrewer',
			name: 'welcomepagebrewer',
			component: Welcomepagebrewer,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/distributorinventory',
			name: 'distributorinventory',
			component: Distributorinventory,
            meta: {
                requiresAuth: true
			},	
		},

		{
			path: '/selecttype',
			name: 'selecttype',
			component: Selecttype,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/drinkdetails',
			name: 'drinkdetails',
			props: true,
			component: Drinkdetails,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/brewerinvoices',
			name: 'brewerinvoices',
			props: true,
			component: Brewerinvoices,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/consumerpo',
			name: 'consumerpo',
			props: true,
			props: (route) => ({ ordersObject: route.query.ordersObject, shippingOption:route.query.shippingOption }),
			component: Consumerpo,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/createinvoice',
			name: 'createinvoice',
			props: true,
			component: Createinvoice,
            meta: {
                requiresAuth: true
			},	
		},
		{
			path: '/invoicescreated',
			name: 'invoicescreated',
			component: Invoicescreated,
			props: true,
			props: (route) => ({ orders: route.query.orders }),
            meta: {
                requiresAuth: true
			},
			
		},

		{
			path: '/showinvoice',
			name: 'showinvoice',
			component: Showinvoice,
			props: true,
			props: (route) => ({ invoicenumber: route.query.invoicenumber, invoicedocid: route.query.invoicedocid}),
            meta: {
                requiresAuth: true
			},
			
		},
		{
			path: '/buyerinvoices',
			name: 'buyerinvoices',
			component: Buyerinvoices,
			props: true,
            meta: {
                requiresAuth: true
			},
			
		},

		{
			path: '/faq',
			name: 'faq',
			component: FAQ,
            meta: {
                requiresAuth: false
			},	
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact,
            meta: {
                requiresAuth: false
			},	
		},
		{
			path: '/subscribe',
			name: 'subscribe',
			component: Subscribe,
            meta: {
                requiresAuth: false
			},	
		},

		//Receivables for brewery
		{
			path: '/receivables',
			name: 'receivables',
			component: Receivables,
            meta: {
                requiresAuth: true
			},	
		},

		//Compose advertising emails to buyers
		{
			path: '/selectcountiesforemail',
			name: 'selectcountiesforemail',
			component: Selectcountiesforemail,
            meta: {
                requiresAuth: true
			},	
		},

		{
			path: '/composeemail',
			name: 'composeemail',
			component: Composeemail,
			props: true,
			props: (route) => ({ counties: route.query.counties}),
            meta: {
                requiresAuth: true
			},	
		},

		{
			path: '/emaildetails',
			name: 'emaildetails',
			component: Emaildetails,
            meta: {
                requiresAuth: true
			},	
		},

		{
			path: '/toemails',
			name: 'toemails',
			component: Toemails,
            meta: {
                requiresAuth: true
			},	
		},

		//Sales report
		{
			path: '/salesreport',
			name: 'salesreport',
			component: Salesreport,
            meta: {
                requiresAuth: true
			},	
		},
		

		//Distributor: Manage brewery
		{
			path: '/managebrewery',
			name: 'managebrewery',
			component: Managebrewery,
			props: true,
			props: (route) => ({distbrewerid: route.query.distbrewerid }),
            meta: {
                requiresAuth:true
			},
			
		},

		//Distributor: Manage reps
		{
			path: '/managereps',
			name: 'managereps',
			component: Managereps,
			meta: {
				requiresAuth: true
			},
			
		},

		//Unsubscribe from emails
		{ 
			path: '/unsubscribe/:unsubscribe', 
			component: Unsubscribe 
		},
		//Unsubscribe from post offering emails
		{ 
			path: '/unsubscribepostoffering/:unsubscribe', 
			component: Unsubscribepostoffering
		},
		
		//Sebd message from order email
		/*
		{
			path: '/ordermessage',
			name: 'ordermessage',
			component: Ordermessage,
			props: true,
			props: (route) => ({ orderid: route.query.orderid }),
            meta: {
                requiresAuth: false
			},	
		},
		*/
		//Send message from email
		{ 
			path: '/ordermessage/:orderid', 
			component: Ordermessage 
		},
		//Accept order from email
		{ 
			path: '/breweracceptorder/:orderid', 
			component: Breweracceptorder 
		},

		//Place order from email
		{ path: '/orderfromemail/:brewershortname/:beerid', component: Orderfromemail },

		//Message buyer
		{ path: '/messageuser/:receiverid/', component: Messageuser },

		//Marketing page
		{
			path: '/marketing',
			name: 'marketing',
			component: Marketing,
            meta: {
                requiresAuth: true
			},
			
		},

		//Landing page
		{
			path: '/landing',
			name: 'landing',
			component: Landing,
            meta: {
                requiresAuth: false
			},
			
		},

		//Forums
		{
			path: '/forums',
			name: 'forums',
			component: Forums,
			meta: {
				requiresAuth: true
			},
			
		},
		{
			path: '/forumthreaddetails',
			name: 'forumthreaddetails',
			component: Forumthreaddetails,
			meta: {
				requiresAuth: true
			},
			
		},

		//For routing forum from emails etc
		{ path: '/forumthreaddetails/:threadid', component: Forumthreaddetails },

		//Unsubscribe from forums
		{ 
			path: '/unsubscribeforums/:unsubscribe', 
			component: Unsubscribeforums
		},

		

		//Marketing Campaign
		{
			path: '/campaign',
			name: 'campaign',
			component: Campaign,
			meta: {
				requiresAuth: true
			},
		},

		//Info pages
		{
			path: '/crafters',
			name: 'crafters',
			component: Crafters,
			meta: {
				requiresAuth: false
			},
		},
		{
			path: '/buyers',
			name: 'buyers',
			component: Buyers,
			meta: {
				requiresAuth: false
			},
		},

		//Buyer service requests
		{
			path: '/buyerservicerequests',
			name: 'buyerservicerequests',
			component: Buyerservicerequests,
			meta: {
				requiresAuth: true
			},
		},
		//Seller service requests
		{
			path: '/sellerservicerequests',
			name: '/sellerservicerequests',
			component: Sellerservicerequests,
			meta: {
				requiresAuth: true
			},
		},

		//Add item for sale
		{
			path: '/additemforsale',
			name: '/additemforsale',
			component: Additemforsale,
			meta: {
				requiresAuth: true
			},
		},
		
		//My items for sale
		{
			path: '/myitemsforsale',
			name: '/myitemsforsale',
			component: Myitemsforsale,
			meta: {
				requiresAuth: true
			},
		},
		
		//Trading Post
		{
			path: '/tradingpost',
			name: '/tradingpost',
			component: Tradingpost,
			meta: {
				requiresAuth: true
			},
		},
		//Sale item details
		{
			path: '/saleitemdetails',
			name: 'saleitemdetails',
			component: Saleitemdetails,
			props: true,
			props: (route) => ({ saleitem: route.query.saleitem}),
            meta: {
                requiresAuth: false
			},
			
		},

		//For routing from emails etc
		{ path: '/saleitemdetails/:saleitemid', component: Saleitemdetails },

		//Unsubscribe from trading post emails
		{ 
			path: '/unsubscribetradingpost/:unsubscribe', 
			component: Unsubscribetradingpost
		},

		
		//Camera view
		
		{
			path: '/cameraview',
			name: 'cameraview',
			component: Cameraview,
			props: true,
			props: (route) => ({ imageid: route.query.imageid}),
            meta: {
                requiresAuth: true
			},
		},

		//Accept or reject order change request
		{ path: '/acceptorderchange/:suborderid/:acceptstatus', component: Acceptorderchange },

	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	  }
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
	const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
		if (to.path=='/allbeers'){
			next('/allbeersnoauth')
		} 
		else next('/login')
		
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})



export default router
